module.exports = __webpack_public_path__ + "images/ru-a11c19.png";